<template>
  <div>
    <div id="player"></div>
  </div>
</template>

<script>
import HikStreamVO from "@/components/player/HikStreamVO";

const {JSPlugin} = window;

export default {
  name: 'WssPlayer',
  props: {
    stream: { // wss 播放地址
      type: HikStreamVO,
      required: true,
      // default: 'wss://ss.hikon.vinlion.com:6014/proxy/172.19.195.250:559/openUrl/dLfUrmM?beginTime=20230719T233211&endTime=20230719T235959'
    }
  },
  data() {
    return {
      timer: null,
      // 当前窗口下标
      windowIndex: 0,
      // 播放器实例
      player: null,
      // 当前回放文件下标
      listCurrentIndex: 0
    }
  },
  watch: {
    key: {
      handler(val, oldVal) {
        this.listCurrentIndex = 0
      },
      deep: true, // true 深度监听
    },
    url: {
      handler(val, oldVal) {
        // console.log(['watch url', !val, val, oldVal])
        if (!!val) {
          this.autoReplay()
        }
      },
      deep: true, // true 深度监听
    },
    listCurrentIndex: {
      handler(val, oldVal) {
        if (val < this.stream.list.length) {
          this.autoReplay()
        }
      },
      deep: true, // true 深度监听
    }
  },
  computed: {
    key() {
      return this.stream.key || '-'
    },
    url() {
      return this.stream.url || ''
    },
    beginTime() {
      const len = this.stream.list.length
      if (len > 0 && this.listCurrentIndex < len) {
        return this.stream.list[this.listCurrentIndex].beginTime
      }
      return null
    },
    endTime() {
      const len = this.stream.list.length
      if (len > 0 && this.listCurrentIndex < len) {
        return this.stream.list[this.listCurrentIndex].endTime
      }
      return null
    },
  },
  created() {
  },
  mounted() {
    this.newJSPlugin()
    this.setWindowControlCallback()
    this.autoReplay()
  },
  beforeDestroy() {
    this.stopAllPlay()
    clearTimeout(this.timer)
    this.timer = null
  },
  methods: {
    // 创建实例
    newJSPlugin() {
      this.windowIndex = 0; // 当前窗口下标
      this.player = new JSPlugin({
        szId: 'player', //需要英文字母开头 必填
        szBasePath: '/static/hik/', // 必填,引用H5player.min.js的js相对路径
        openDebug: true,
        // 当容器div#player有固定宽高时，可不传iWidth和iHeight，窗口大小将自适应容器宽高
        // iWidth: document.body.clientWidth,
        // iHeight: document.body.clientHeight,

        // 分屏播放，默认最大分屏4*4
        // iMaxSplit: 4,
        // iCurrentSplit: 1,

        // 样式
        // oStyle: {
        //   border: "#343434",
        //   borderSelect: "#FFCC00",
        //   background: "#000"
        // }
      })
      // console.log(['this.player', this.player])
    },
    // 事件初始化: JS_SetWindowControlCallback(events)
    setWindowControlCallback() {
      this.player
        .JS_SetWindowControlCallback({
          windowEventSelect: (index) => {  //插件选中窗口回调
            // this.windowIndex = index;
            console.log(['windowEventSelect', index]);
            this.capturePicture()
          },
          pluginErrorHandler: (index, errorCode, oError) => {  //插件错误回调
            // do you want...
            // 取流失败，流中断等错误都会触发该回调函数，请自行对照错误码表进行判断。
            // 业务上层可在此做一些个性化操作，如：个性化错误信息展示，重新取流等。
            console.error([`播放中断，错误码：${errorCode} 。3秒后尝试重新连接`, 'pluginErrorHandler', index, errorCode, oError]);
            // this.$message.error(`播放中断，错误码：${errorCode} 。3秒后尝试重新连接`)
            this.timer = setTimeout(() => {
              this.stopAllPlay()
              this.$emit('reconnect', this.stream)
            }, 3000)
          },
          windowEventOver: (index) => {  //鼠标移过回调
            // console.log(['windowEventOver']);
          },
          windowEventOut: (index) => {  //鼠标移出回调
            // console.log(['windowEventOut']);
          },
          windowEventUp: (index) => {  //鼠标mouseup事件回调
            // console.log(['windowEventUp']);
          },
          windowFullCcreenChange: (bFull) => { //全屏切换回调
            console.log(['windowFullCcreenChange']);
          },
          firstFrameDisplay: (index, iWidth, iHeight) => { //首帧显示回调
            console.log(['firstFrameDisplay']);
          },
          performanceLack: () => {  //性能不足回调
            this.$message.error(`播放客户端资源不足`)
          },
          StreamEnd: (index) => {  //回放结束回调,返回对应测窗口id
            this.listCurrentIndex++
            console.log(['StreamEnd', this.listCurrentIndex]);
          },
          oEventCallback: (data) => {
            console.log(['oEventCallback', data]);
          }
        })
        .then(() => {
          this.player
            .JS_SetOptions({
              bSupporDoubleClickFull: false, // 是否双击窗口全屏，默认支持
              // bSupportSound: true, // 是否支持音频，默认支持
              // bOnlySupportMSE: false, // 只支持 MSE
              // bOnlySupportJSDecoder: true // 只支持 JSDecoder
            })
            .then(() => {
              console.log('JS_SetOptions')
            })
        })
    },
    autoReplay() {
      //console.log(['autoReplay', {url: this.stream.url, beginTime: this.beginTime, endTime: this.endTime}])
      if (!this.stream.url) {
        return
      }
      this.player.JS_Play(
        this.stream.url,
        {
          playURL: this.stream.url, // 流媒体播放时必传
          mode: 1, // 解码类型：0=普通模式; 1=高级模式 默认为0
        },
        this.windowIndex, //当前窗口下标
        // 回放参数
        this.beginTime,
        this.endTime,
        // '2023-07-19T23:36:12.000+08:00', // startTime
        // '2023-07-20T00:00:00.000+08:00', // endTime
      ).then(
        () => {
          console.info('JS_Play success');
          this.player.JS_OpenSound(this.windowIndex).then(
              () => {
                console.info('JS_OpenSound success');
              },
              (err) => {
                console.info('JS_OpenSound failed');
              }
          );
        },
        (err) => {
          console.error('播放失败，请重新打开页面 JS_Play failed:', err);
          // this.$message.error('播放失败，请重新打开页面')
        }
      );
    },
    // 截图
    capturePicture() {
      this.player.JS_CapturePicture(this.windowIndex, 'fileName', 'JPEG', base64 => {
        // console.info('JS_CapturePicture success', base64); //2.1.0开始全是base64，之前的版本存在blob或者是base64
        this.$emit('capture-picture', base64)
      })
    },
    // 停止播放
    stopAllPlay() {
      this.player.JS_StopRealPlayAll().then(
        () => {
          console.log('stopAllPlay success')
        },
        e => {
          console.error(e)
        }
      )
    },
  }
}
</script>
<style scoped lang="less">
#player {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 0;
  overflow: hidden;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/player/WssPlayer.vue